var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, customElement, html, LitElement, property } from 'lit-element';
import Auth from '../services/auth';
let ConfigurableCmsBlock = class ConfigurableCmsBlock extends LitElement {
    constructor() {
        super(...arguments);
        this.config = null;
        this.id = '';
    }
    firstUpdated() {
        if (this.config === null) {
            this.config = {
                closeable: null,
                visibility: 'all',
                width: 'container',
                background: null,
                bottomShadow: false,
            };
        }
        this.setVisibility();
    }
    static get styles() {
        return css `
            :host {
                position: relative;
                user-select: none;
                height: auto;
                width: auto;
                z-index: 1;
            }

            :host(.visible) {
                display: block;
            }

            .closeable {
                width: 20px;
                height: 20px;
                position: absolute;
                border-radius: 50%;
                margin: 3px;
                cursor: pointer;
                transition: background-color 0.2s ease-in-out;
            }

            .closeable.top-left {
                top: 0;
                left: 0;
            }

            .closeable.top-right {
                top: 0;
                right: 0;
            }

            .closeable.bottom-left {
                bottom: 0;
                left: 0;
            }

            .closeable.bottom-right {
                bottom: 0;
                right: 0;
            }

            @media (max-width: 1262px) {
                .closeable.top-left {
                    top: 0;
                    left: 5px;
                }

                .closeable.top-right {
                    top: 0;
                    right: 5px;
                }

                .closeable.bottom-left {
                    bottom: 0;
                    left: 5px;
                }

                .closeable.bottom-right {
                    bottom: 0;
                    right: 5px;
                }
            }

            .closeable::after {
                content: '\\00D7';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: var(--inverse-font-color);
                font-size: 2rem;
            }

            .closeable.primary {
                background-color: var(--color-primary);
            }

            .closeable.primary:hover {
                background-color: var(--color-primary-dark);
            }

            .closeable.secondary {
                background-color: var(--color-important-accents);
            }

            .closeable.secondary:hover {
                background-color: var(--color-important-accents-dark);
            }

            .width-wrapper.width-full-bg .slot-wrapper,
            .width-wrapper.width-container .slot-wrapper {
                padding-left: calc((100% - 1248px) / 2);
                padding-right: calc((100% - 1248px) / 2);
            }

            .width-wrapper.width-full .slot-wrapper {
                width: 100%;
            }

            .width-wrapper.width-full.bottom-shadow,
            .width-wrapper.width-full-bg.bottom-shadow {
                box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
            }
        `;
    }
    render() {
        return html `
            <div>
                <div
                    class="width-wrapper width-${this.config?.width} ${this.config?.width !== 'container' &&
            this.config?.bottomShadow
            ? 'bottom-shadow'
            : ''}"
                    style="${this.config?.width === 'full-bg' && this.config?.background
            ? `background-color: ${this.config.background}`
            : ''}"
                >
                    <div class="slot-wrapper">
                        <div style="position: relative">
                            ${this.config?.closeable
            ? html `
                                      <div
                                          class="closeable ${this.closeButtonPosition()} ${this.closeButtonColor()}"
                                          @click="${this.close}"
                                      ></div>
                                  `
            : ``}
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    closeButtonPosition() {
        if (this.config?.closeable) {
            return this.config.closeable.position;
        }
        return 'top-right';
    }
    closeButtonColor() {
        if (this.config?.closeable) {
            return this.config.closeable.color;
        }
        return 'secondary';
    }
    getTime() {
        if (this.config?.closeable) {
            return this.config.closeable.time;
        }
        // domyślnie zamykamy na 24h
        return 24;
    }
    // Utwórz wpis w localstorage zawierający id bloku oraz czas do którego ma być ukryty
    close() {
        if (this.config?.closeable) {
            const time = new Date().getTime() + this.getTime() * 60 * 60 * 1000;
            localStorage.setItem(`cms-block-${this.id}`, time.toString());
            this.setVisibility();
        }
    }
    setVisibility() {
        let visible = true;
        // nie obsługujemy bloków bez przypisanego ID - mogłoby to doprowadzić do niekontrolowanego wyświetlania
        // i ukrywania bloków na stronie
        if (this.id === '') {
            return;
        }
        // sprawdz czy czas ukrycia bloku minął
        // jeśli tak to usuń wpis z localstorage i pokaż blok
        const time = localStorage.getItem(`cms-block-${this.id}`);
        if (time) {
            const now = new Date().getTime();
            if (now > parseInt(time)) {
                localStorage.removeItem(`cms-block-${this.id}`);
                visible = true;
            }
            else {
                visible = false;
            }
        }
        // jeśli blok jest widoczny to dodatkowo sprawdzamy czy ma być widoczny dla aktualnego klienta
        if (visible) {
            this.getCustomerVisibility()
                .then((result) => {
                if (result) {
                    this.classList.add('visible');
                    this.classList.remove('hidden');
                }
                else {
                    this.classList.remove('visible');
                    this.classList.add('hidden');
                }
            })
                .catch(() => {
                console.error('Could not get fetch customer visibility');
            });
        }
        else {
            this.classList.remove('visible');
            this.classList.add('hidden');
        }
    }
    async getCustomerVisibility() {
        // wyświetlamy blok dla wszystkich
        if (this.config?.visibility === 'all') {
            return true;
        }
        const state = await Auth.getState();
        if (state.loggedIn && this.config?.visibility === 'logged_in') {
            return true;
        }
        else if (!state.loggedIn && this.config?.visibility === 'logged_out') {
            return true;
        }
        return false;
    }
};
__decorate([
    property({ type: Object })
], ConfigurableCmsBlock.prototype, "config", void 0);
__decorate([
    property({ type: String })
], ConfigurableCmsBlock.prototype, "id", void 0);
ConfigurableCmsBlock = __decorate([
    customElement('configurable-cms-block')
], ConfigurableCmsBlock);
export default ConfigurableCmsBlock;
